import { z } from 'zod';

import { DeviceSchema } from './device';

export const createGlobalApiDetailsBaseSchema = <T extends z.ZodTypeAny>(
  payerSchema: T
) =>
  z.object({
    id: z.string().uuid(),
    internalReference: z.string().nullable(),
    currency: z.string(),
    device: DeviceSchema,
    payer: payerSchema,
  });
